import { render, staticRenderFns } from "./RequestMain.vue?vue&type=template&id=6ad0f65d&scoped=true"
import script from "./RequestMain.vue?vue&type=script&lang=js"
export * from "./RequestMain.vue?vue&type=script&lang=js"
import style0 from "./RequestMain.vue?vue&type=style&index=0&id=6ad0f65d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad0f65d",
  null
  
)

export default component.exports